import { DatePicker, Portal } from '@chakra-ui/react'
import { CalendarDate, getLocalTimeZone } from '@internationalized/date'
import { LuCalendar } from 'react-icons/lu'
import { useMemo, useState } from 'react'

type Props = {
    value: Date
    setDate?: (newDate: Date) => void
    placeholder?: string
}

const toCalendarDate = (date: Date) =>
    new CalendarDate(date.getFullYear(), date.getMonth() + 1, date.getDate())

export const DateChooser = ({ value, setDate, placeholder = 'Select date' }: Props) => {
    const [open, setOpen] = useState(false)

    const pickerValue = useMemo(() => [toCalendarDate(value)], [value])

    return (
        <DatePicker.Root
            open={open}
            onOpenChange={(e) => setOpen(e.open)}
            value={pickerValue}
            size="sm"
            variant="outline"
            onValueChange={(details) => {
                const next = details.value?.[0]
                if (!next) return

                setDate?.(next.toDate(getLocalTimeZone()))
                setOpen(false)
            }}
        >
            <DatePicker.Control w="160px">
                <DatePicker.Input placeholder={placeholder} />
                <DatePicker.IndicatorGroup>
                    <DatePicker.Trigger>
                        <LuCalendar />
                    </DatePicker.Trigger>
                </DatePicker.IndicatorGroup>
            </DatePicker.Control>

            <Portal>
                <DatePicker.Positioner>
                    <DatePicker.Content>
                        <DatePicker.View view="day">
                            <DatePicker.Header />
                            <DatePicker.DayTable />
                        </DatePicker.View>

                        <DatePicker.View view="month">
                            <DatePicker.Header />
                            <DatePicker.MonthTable />
                        </DatePicker.View>

                        <DatePicker.View view="year">
                            <DatePicker.Header />
                            <DatePicker.YearTable />
                        </DatePicker.View>
                    </DatePicker.Content>
                </DatePicker.Positioner>
            </Portal>
        </DatePicker.Root>
    )
}
